import { Grid, Typography } from "@mui/material";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../assets/css/header.css";

const Header = ({ isIta: isItaProp }) => {
  const location = useLocation();

  const isIta =
    isItaProp !== null && isItaProp !== undefined
      ? isItaProp
      : location.pathname.includes("persona-fisica") ||
        location.pathname.includes("persona-giuridica");
  return (
    <Grid
      container
      className="bg-blue-dark"
      style={{
        display: "flex",
        justifyContent: "center",
        padding: "5px 0px",
        alignItems: "center",
      }}
    >
      <Grid
        item
        xs={2}
        md={1}
        style={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <div className="logo-lexia-header" />
      </Grid>

      <Grid
        item
        xs={8}
        md={10}
        style={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Typography className="color-light title-header">
          {isIta
            ? "Raccolta dati ai fini anti-riciclaggio"
            : "Data collection for anti-money laundering purpose"}
        </Typography>
      </Grid>

      <Grid
        item
        xs={2}
        md={1}
        style={{
          display: "flex",
          justifyContent: "center",
        }}
      />
    </Grid>
  );
};

export default Header;
